import React, { useEffect, useState } from 'react'
import DataTableLayer from '../../components/DataTableLayer'
import { Icon } from '@iconify/react/dist/iconify.js'
import { Link } from 'react-router-dom'
import UsersForm from './UsersForm'
import ModalAlert from '../../components/ModalAlert'
import PostByAgg from '../../utils/axios'
import { useAuth } from '../../context/AuthContext'
import LottieLoading from '../../components/child/LottieLoading'

const Users = () => {

    const [openForm, setOpenForm] = useState(false)
    const [actionMode, setActionMode] = useState('create');
    const [selectedUser, setSelectedUser] = useState(null);  
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [openModalError, setOpenModalError] = useState(<div></div>)
    const [selectedRow, setSelectedRow] = useState(null);
    const [data, setData]= useState([]);
    const [pagination, setPagination] = useState({
              pageIndex: 0,
              pageSize: 10,
              totalRecords: 10,
              totalPages: 0,
          });
      const [isLoading, setIsLoading] = useState(false)

    const {musicLabelCode, email} = useAuth();


    const columns = [
        {
            accessorKey: 'username',
            header: 'Username',
        },
        {
            accessorKey: 'full_name',
            header: 'Full Name',
        },
        {
            accessorKey: 'email',
            header: 'Email',
        },
        {
            accessorKey:'status_name',
            header:'Status',
            cell: ({ row }) => {
                const status = row.original.status_name;
                if (status === 'ACTIVE') {
                  return <span className="badge bg-success text-white">{status}</span>;
                } else if (status === 'WAITING') {
                  return <span className="bg-warning text-white">{status}</span>;
                } else {
                  return <span className="bg-muted text-white">{status}</span>;
                }
            }
        },
        {
            accessorKey: "action", // Add a custom column for actions
            header: "Actions",
            cell: ({ row }) => (
                <div className="dropdown">
                    <button
                        className="btn px-18 py-11 text-primary-light"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <Icon
                            icon="ph:dots-three-outline-fill"
                            className="menu-icon"
                        />
                    </button>
                    <ul className="dropdown-menu">
                        <li>
                            <Link
                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                to="#"
                                onClick={() => handleAction('view', row.original)}
                            >
                                View
                            </Link>
                        </li>
                        <li>
                            <Link
                                className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
                                to="#"
                                onClick={()=> handleAction('delete', row.original)}
                            >
                                Delete
                            </Link>
                        </li>
                        
                    </ul>
                </div>
            ),
        },
    ]

    const GetUserAdmin = () => {
        setIsLoading(true);
        const url = 'user/um/v1/user-admin-label';
        PostByAgg({
            url,
            body: {
                'music_label_code': musicLabelCode,
                "page":pagination.pageIndex + 1,
                "rows":pagination.totalRecords,
            },
            onResponse : onResponseListAdmin,
            onError: onErrorListAdmin
        })
    }

    const onResponseListAdmin = (response) => {
        setIsLoading(false)
        console.log('Response total admin label:', response.data.data.total);
        console.log('Response admin label:', response.data.data.list_user);
        if (response.data.data && response.data.data.total > 0) {
            const totalRecords = response.data.data.total;
            // const rows = pagination.rows
            const totalPages = Math.ceil(totalRecords / pagination.rows);
          setPagination((prev) => ({
              ...prev,
              totalRecords: totalRecords,
              totalPages: totalPages,
              rows: totalRecords,
            //   pageSize: totalRecords,
              // pageIndex: 0,
            }));
            setData(response.data.data.list_user)
        }else if(response.data.data.total === 0){
            setIsLoading(false)
            setData([]);
        }
    }

    const onErrorListAdmin = (error) => {
        if(error.response.data.code === "4003400"){
            setOpenModalError(
              <ModalAlert
                show={true}
                type={"failed"}
                text={error.response.data.message.id}
                action={() => {}}
              />
            )
          }
          else{
            setOpenModalError(
              <ModalAlert
                show={true}
                type={"failed"}
                text={error.response.data.message.id}
                action={() => {}}
              />
            )
          }
    }
    
    useEffect(() => {
        GetUserAdmin()
    },[pagination.pageIndex, pagination.pageSize])

    const handleAdd = () => {
        setActionMode('create');
        setSelectedUser(null);
        setOpenForm(true);
    }

    const handleClose = () => {
        setOpenForm(false); // Close the modal
    };
    const handleAction = (action, row) => {
        console.log(`Action: ${action}`);
        setActionMode(action);
        setSelectedUser(row); 
        if (action === 'view') {
            setSelectedRow(row);
            console.log("Selected Row for View:", row)
            setOpenForm(true);
        }else if (action === 'delete') {
            setSelectedRow(row); // Set the user data for deletion
            setShowConfirmModal(true); // Show the delete confirmation modal
            console.log("Selected Row for Deletion:", row);
        } else {
            setOpenForm(true);
        }
    };

    const handleDelete = (row) => {
        console.log('Deleting user with ID:', row);
        const url = 'user/um/v1/user-delete';
        PostByAgg({
            url,
            body: {
                'user_code': row.user_code,
                'update_by': email
            },
           onResponse: onDeleteResponse,
           onError: onDeleteError
        })
        setShowConfirmModal(false);

    };

    const onDeleteResponse = (response) => {
        console.log('Response delete:', response);
        if(response.data) {
            setShowSuccessModal(
                <ModalAlert
                    show={true}
                    title="Success"
                    type={"success"}
                    message={response.data.message.id}
                    action={() => {
                        setShowSuccessModal(<div></div>)
                        GetUserAdmin();
                    }}
                />
            );
        }else{
            setShowSuccessModal(
                <ModalAlert
                    show={true}
                    type={"failed"}
                    message={response.data.message.id}
                    action={() => {
                        setShowSuccessModal(<div></div>)
                        GetUserAdmin();
                    }}
                />
            );
        }
    };  
    
    const onDeleteError = (error) => {
        console.log('Error delete:', error);
        if(error.response) {
            setShowSuccessModal(
                <ModalAlert
                    show={true}
                    type={"failed"}
                    message={error.data.message.id}
                    action={() => {
                        setShowSuccessModal(<div></div>)
                        GetUserAdmin();
                    }}
                />
            );
        }
    };

    const handleDownload = () => {
        console.log('Downloading data...');
    };

    const refreshData = () => {
        GetUserAdmin();
      }

  return (
    <div>
        <DataTableLayer columns={columns} data={data} pagination={true} title={"Users Table"} showButtons={true} btnTitle={"Add"} showDownloadButton={true} onClick={handleAdd} onDownload={handleDownload} />
        {
            openForm && (
                <UsersForm
                    open={openForm}
                    mode={actionMode}
                    user={selectedUser} // Pass selected user data
                    handleClose={handleClose}
                    refreshData={refreshData}
                    onClose={() => setOpenForm(false)} 
                />
            )  
        }

        {showConfirmModal && (
                <ModalAlert
                    show={true}
                    type="confirm"
                    code="Delete Confirmation"
                    text={`Are you sure you want to delete this user: ${selectedRow.username}?`}
                    open={showConfirmModal}
                    action={() => {
                        handleDelete(selectedRow);
                    }}
                    cancel={() => setShowConfirmModal(false)}
                />
            )}
            {openModalError}
            {showSuccessModal}
        {isLoading && <LottieLoading text="Loading..." />}
    </div>
  )
}

export default Users